/***
 * @Author: ZhaoG
 * @Date: 2025-04-09 10:57:57
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-02-10 09:40:59
 * @FilePath: \sra-fe\src\router\index.js
 * @Description:
 */
import Vue from 'vue'
import Router from 'vue-router'
import state from '@/store'
import Layout from '@/views/layout/Layout'
import ParentView from '@/views/template/index'

Vue.use(Router)

/* Layout */

/* Router Modules */
// import commonRouter from './modules/common'
// import componentsRouter from './modules/components'
// import chartsRouter from './modules/charts'
// import tableRouter from './modules/table'
// import nestedRouter from './modules/nested'
// import statisticRouter from './modules/statistic'
// import approvalRouter from './modules/approval'
// import organizationRouter from './modules/organization'
// import tmplRouter from './modules/tmpl'

/** note: sub-menu only appear when children.length>=1
 *  detail see  https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 **/

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    will control the page roles (you can set multiple roles)
    title: 'title'               the name show in sub-menu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if true, the page will no be cached(default is false)
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
    affix: true                  if true, the tag will affix in the tags-view
  }
 **/
export const constantRouterMap = [
  {
    path: '/to-be-built',
    component: Layout,
    redirect: '/to-be-built',
    name: 'to-be-built',
    meta: {
      title: '待建',
      icon: 'nested'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/template/under-contribute/index'),
        name: 'to-be-built-index',
        meta: {
          title: '建设中...'
        }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    redirect: '/index'
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404-new'),
    hidden: true
  },
  {
    path: '/index',
    component: () => import('@/views/register/index'),
    meta: {
      title: '注册'
    }
  },
  {
    path: '/transferPage',
    component: () => import('@/views//register/subconinfo/steps/transferPage'),
    meta: {
      title: '中转页'
    }
  },
  // {
  //   path: "/subReady",
  //   component: () => import("@/views/register/subcontractor/subReady.vue"),
  //   meta: {
  //     title: "分包商申请合作准备信息"
  //   }
  // },
  // {
  //   path: "/eqReady",
  //   component: () => import("@/views/register/equipment/eqReady.vue"),
  //   meta: {
  //     title: "装备供应商申请合作准备信息"
  //   }
  // },

  {
    path: '/maReady01',
    component: () => import('@/views/register/material/maReady.vue'),
    meta: {
      title: '物资供应商申请合作准备信息'
    },
    children: [
      {
        path: '/maReady01',
        component: () => import('@/views/register/material/registerStep/maReady01.vue'),
        meta: {
          title: '物资供应商申请合作准备信息'
        }
      },
      {
        path: '/maReady02',
        component: () => import('@/views/register/material/maFastReg/maReady02.vue'),
        meta: {
          title: '入网供应商须知'
        }
      },
      {
        path: '/maPerfectInfo/moralAgreement',
        component: () => import('@/views/register/material/maPerfectInfo/moralAgreement.vue'),
        meta: {
          title: '恪守商业道德协议'
        }
      },
      {
        path: '/maPerfectInfo/applyUsername',
        component: () => import('@/views/register/material/maPerfectInfo/applyUsername.vue'),
        meta: {
          title: '申请用户名'
        }
      },
      {
        path: '/maPerfectInfo/basicInformation',
        component: () => import('@/views/register/material/maPerfectInfo/basicInformation.vue'),
        meta: {
          title: '供应商基本信息'
        }
      },
      {
        path: '/maPerfectInfo/contactInformation',
        component: () => import('@/views/register/material/maPerfectInfo/contactInformation.vue'),
        meta: {
          title: '联系人信息'
        }
      },
      {
        path: '/maPerfectInfo/productInformation',
        component: () => import('@/views/register/material/maPerfectInfo/productInformation.vue'),
        meta: {
          title: '产品信息'
        }
      },
      {
        path: '/maPerfectInfo/financialInformation',
        component: () => import('@/views/register/material/maPerfectInfo/financialInformation.vue'),
        meta: {
          title: '财务信息'
        }
      },
      {
        path: '/maPerfectInfo/historyCooperation',
        component: () => import('@/views/register/material/maPerfectInfo/historyCooperation.vue'),
        meta: {
          title: '历史合作业绩'
        }
      },
      {
        path: '/maPerfectInfo/greenLowCarbon',
        component: () => import('@/views/register/material/maPerfectInfo/greenLowCarbon.vue'),
        meta: {
          title: '绿色低碳'
        }
      },
      {
        path: '/maPerfectInfo/qualificationDocuments',
        component: () => import('@/views/register/material/maPerfectInfo/qualificationDocuments.vue'),
        meta: {
          title: '资质文件'
        }
      },
    ]
  },
  {
    path: '/regView/mobileValidate',
    component: () => import('@/views/register/regView/mobileValidate.vue'),
    meta: {
      title: '手机号认证'
    }
  },
  {
    path: '/regView/supRegDetail',
    component: () => import('@/views/register/regView/supRegDetail.vue'),
    meta: {
      title: '注册详情页(国内)'
    }
  },
  {
    path: '/regView/foreignSupRegDetail',
    component: () => import('@/views/register/regView/foreignSupRegDetail.vue'),
    meta: {
      title: '注册详情页(国外)'
    }
  },
  {
    path: '/business-open-shop',
    component: () => import('@/views/business-open-shop/index.vue'),
    redirect: 'business-open-shop/ready-data',
    meta: {
      title: '商家开店'
    },
    children: [
      {
        path: 'ready-data',
        component: () =>
          import('@/views/business-open-shop/ready-data/index.vue'),
        meta: {
          title: '商家开店准备资料'
        }
      },
      {
        path: 'register',
        component: () =>
          import('@/views/business-open-shop/register/index.vue'),
        meta: {
          title: '商家开店快速注册'
        }
      },
      {
        path: 'input-business-info',
        component: () =>
          import(
            '@/views/business-open-shop/business-input-info/input-business-info.vue'
          ),
        meta: {
          title: '商家录入信息'
        }
      },
      {
        path: 'contract-input-info',
        component: () =>
          import(
            '@/views/business-open-shop/contract-input-info/index.vue'
          ),
        meta: {
          title: '商家录入信息'
        }
      },
      {
        path: 'apply-shop-info/:businessId?',
        component: () =>
          import('@/views/business-open-shop/apply-shop/apply-shop-info.vue'),
        meta: {
          title: '录入店铺信息'
        }
      },
      {
        path: 'approval/:shopId/:shopType',
        component: () =>
          import('@/views/business-open-shop/approval/approval-view.vue'),
        meta: {
          title: '审批进度页面'
        }
      },
      {
        path: 'shop-detail-info/:shopId',
        name: 'shop-detail-info',
        component: () =>
          import(
            '@/views/business-open-shop/shop-detail-info/shop-detail-info.vue'
          ),
        meta: {
          title: '查看详情页面'
        }
      }
    ]
  },
  {
    path: '/lessor-open-shop',
    component: () => import('@/views/lessor-open-shop/index.vue'),
    meta: {
      title: '开店申请'
    }
  },
  {
    path: '/approval/detail',
    component: () => import('@/views/lessor-open-shop/approval/index.vue'),
    meta: {
      title: '承运商开店审批进度'
    }
  },
  {
    path: '/subcon-submit-success',
    component: () => import('@/views/register/subconinfo/subcon-submit-success.vue'),
    meta: {
      title: '分包商提交成功页面'
    },
  },
  {
    path: '/subcontractor-registration',
    component: () => import('@/views/register/subconinfo/index.vue'),
    meta: {
      title: '分包商'
    },
  },
  {
    path: '/expert-registration',
    component: () => import('@/views/register/expert/index.vue'),
    meta: {
      title: '外部专家注册'
    },
  },
  {
    path: '/expert-submit-success',
    component: () => import('@/views/register/expert/expert-submit-success.vue'),
    meta: {
      title: '外部专家注册提交成功页面'
    },
  },
  {
    path: '/supplier-registration',
    component: () => import('@/views/register/subconinfo/supplierSteps/index.vue'),
    meta: {
      title: '供应商'
    },
  },
  {
    path: '/supplier-registration-secondStep',
    component: () => import('@/views/register/subconinfo/supplierSteps/secondStep.vue'),
    meta: {
      title: '第二步'
    },
  },
  {
    path: '/test',
    component: () => import('@/views/test/test'),
    hidden: true
  },
  {
    path: '/*',
    component: () => import('@/views/error-page/404-new'),
    hidden: true
  }
]

const router = new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})

export default router
